export const reviewsLanding = [
	{
		id: 1,
		title: 'It was simple',
		text: 'It was simple, inexpensive and I got to make all kinds of IA pictures from the most professionnal to the goofiest',
		author: 'Hélène',
		rating: 5,
		link: 'https://www.trustpilot.com/reviews/6a2c747c9f14e9fc0955c10d',
	},
	{
		id: 3,
		title: 'I truly love this site-it’s so worth…',
		text: 'I truly love this site-it’s so worth it!! You absolutely have to give it a try!!!!',
		author: 'Kia Roussel',
		rating: 5,
		link: 'https://www.trustpilot.com/reviews/6a26cd61364555aec8ae0c9f',
	},
	{
		id: 4,
		title: 'Quick results that gave me a great idea…',
		text: 'Quick results that gave me a great idea for a new hairstyle.',
		author: 'Janice Andrews',
		rating: 5,
		link: 'https://www.trustpilot.com/reviews/6a21aafdc0fffb813192b118',
	},
	{
		id: 5,
		title: 'It wasn`t too difficult to get the…',
		text: 'It wasn`t too difficult to get the result I wanted.  There were lots of options, and these allowed self-correction.',
		author: 'barbara hart',
		rating: 5,
		link: 'https://www.trustpilot.com/reviews/6a19dc042b8342003624fd1c',
	},
	{
		id: 6,
		title: 'Easy to and simple to use',
		text: 'Easy to and simple to use',
		author: 'Ken Platt',
		rating: 5,
		link: 'https://www.trustpilot.com/reviews/6a19aac52ea0e0cfc6261f10',
	},
	{
		id: 7,
		title: 'Literal magic',
		text: 'Literal magic! I love it!',
		author: 'Jennifer Gonzales',
		rating: 5,
		link: 'https://www.trustpilot.com/reviews/6a190f4d9ed764a4e83cfaf9',
	},
	{
		id: 8,
		title: 'Liftapp.ai is amazing',
		text: 'Liftapp.ai is amazing- perfectly and seamlessly did exactly what I needed!',
		author: 'Charlie Pouliot',
		rating: 5,
		link: 'https://www.trustpilot.com/reviews/6a15111696451331a4a9c59b',
	},
];

export const reviewsRemoveBG = [
	{
		id: 1,
		title: 'It was simple',
		text: 'It was simple, inexpensive and I got to make all kinds of IA pictures from the most professionnal to the goofiest',
		author: 'Hélène',
		rating: 5,
		link: 'https://www.trustpilot.com/reviews/6a2c747c9f14e9fc0955c10d',
	},
	{
		id: 3,
		title: 'I truly love this site-it’s so worth…',
		text: 'I truly love this site-it’s so worth it!! You absolutely have to give it a try!!!!',
		author: 'Kia Roussel',
		rating: 5,
		link: 'https://www.trustpilot.com/reviews/6a26cd61364555aec8ae0c9f',
	},
	{
		id: 4,
		title: 'Quick results that gave me a great idea…',
		text: 'Quick results that gave me a great idea for a new hairstyle.',
		author: 'Janice Andrews',
		rating: 5,
		link: 'https://www.trustpilot.com/reviews/6a21aafdc0fffb813192b118',
	},
	{
		id: 5,
		title: 'It wasn`t too difficult to get the…',
		text: 'It wasn`t too difficult to get the result I wanted.  There were lots of options, and these allowed self-correction.',
		author: 'barbara hart',
		rating: 5,
		link: 'https://www.trustpilot.com/reviews/6a19dc042b8342003624fd1c',
	},
	{
		id: 6,
		title: 'Easy to and simple to use',
		text: 'Easy to and simple to use',
		author: 'Ken Platt',
		rating: 5,
		link: 'https://www.trustpilot.com/reviews/6a19aac52ea0e0cfc6261f10',
	},
	{
		id: 7,
		title: 'Literal magic',
		text: 'Literal magic! I love it!',
		author: 'Jennifer Gonzales',
		rating: 5,
		link: 'https://www.trustpilot.com/reviews/6a190f4d9ed764a4e83cfaf9',
	},
	{
		id: 8,
		title: 'Liftapp.ai is amazing',
		text: 'Liftapp.ai is amazing- perfectly and seamlessly did exactly what I needed!',
		author: 'Charlie Pouliot',
		rating: 5,
		link: 'https://www.trustpilot.com/reviews/6a15111696451331a4a9c59b',
	},
];
